export const idlFactory = ({ IDL }) => {
  const Credential = IDL.Record({
    'id' : IDL.Text,
    'username' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'password' : IDL.Text,
    'name' : IDL.Text,
    'device_id' : IDL.Opt(IDL.Text),
    'created_at' : IDL.Int64,
    'created_by' : IDL.Principal,
    'expiration' : IDL.Int64,
    'credential_type' : IDL.Text,
  });
  return IDL.Service({
    'cleanup_expired_credentials' : IDL.Func(
        [],
        [IDL.Variant({ 'Ok' : IDL.Nat32, 'Err' : IDL.Text })],
        [],
      ),
    'create_credential' : IDL.Func(
        [
          IDL.Text,
          IDL.Text,
          IDL.Text,
          IDL.Opt(IDL.Text),
          IDL.Text,
          IDL.Text,
          IDL.Int64,
          IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
        ],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'delete_credential' : IDL.Func(
        [IDL.Text],
        [IDL.Variant({ 'Ok' : IDL.Bool, 'Err' : IDL.Text })],
        [],
      ),
    'get_credential' : IDL.Func([IDL.Text], [IDL.Opt(Credential)], ['query']),
    'list_active_credentials' : IDL.Func([], [IDL.Vec(Credential)], ['query']),
    'list_credentials' : IDL.Func([], [IDL.Vec(Credential)], ['query']),
    'list_credentials_by_device' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(Credential)],
        ['query'],
      ),
    'list_credentials_by_type' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(Credential)],
        ['query'],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
